export default __webpack_public_path__ + "static/media/Instructor Image Placeholder.1418878a.svg";